"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredHiddenChatsContext = void 0;
const react_1 = require("react");
exports.FilteredHiddenChatsContext = (0, react_1.createContext)({});
